// Our modules / classes
// import Search from './modules/search';
import newSearch from './modules/newSearch';
import { accordion } from './modules/accordion';
import { animations } from './modules/observers';

// Instantiate a new object using our modules / classes

const url = document.URL;

// OLD SEARCH FEATURE
// if (url == "https://nslaureates.ca/laureates/" || url == "http://nsbhf-legacy-website.local/laureates/" ) {
//   const search = new Search();
// }

if (document.URL.includes('/faq/')) {
  accordion();
  console.log("Welcome to the FAQ section");
}

// we can input mutiple classes if we want to be more specific
if (document.getElementsByClassName("text-animation")) {
  animations();
}

if (document.getElementsByClassName("line-animation")) {
  animations();
}

if (document.getElementsByClassName("gallery").length > 0) {
  const search = new newSearch();
  console.log("\n");
  console.log("--------------------------------------");
  console.log("Welcome to the Laureate Archive");
  console.log("--------------------------------------");
  console.log("\n");
}



